module.exports = __webpack_public_path__ + "static/media/Christopher Hogan Headshot.7d932d35.png";